import React, { useEffect, useMemo, useState } from "react"
import { useTranslation } from "react-i18next"
import { glyphs } from "../../../Styles"
import { NewSelect, NewModal, Button } from "../.."
import { useAppSelector } from "../../../Store"
import { Graph_QL } from "../../../Services"
import { useAnimal } from "../../../Services/Agrisys_GqlDataCaller/AnimalDataCalls/useAnimal"
import { LfLocation } from "../../../Services/Agrisys_GqlDataCaller/LocationFeedingCalls/GQLCalls/getLfStructureCall"
interface MoveAnimalModalProps {
  pen?: LfLocation
  isModalOpen: boolean
  onClose: () => void
}

export default function MoveAnimalModal({pen, isModalOpen, onClose}:MoveAnimalModalProps) {
  const { t } = useTranslation();
  const [activePen, setActivePen] = useState(pen)
  const animal = pen?.animals && pen.animals.length ? pen.animals[0] : undefined


  useEffect(() => {
    setActivePen(pen)
  }, [pen])

  return(<>
    <NewModal
      modalState={isModalOpen}
      predefinedButtons={{
        onClose: onClose
      }}
      header={t("operationsPages.moveAnimal", {defaultValue: "move animal"})}
      subHeader={`${t("animalPages.animal.animal", {defaultValue: "animal"})} ${animal?.animal_id}`}
      mainContent={
        <div style={{width: "100%", minWidth: "310px", minHeight: "400px", padding: "20px", boxSizing: "border-box", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "space-between", gap: "20px"}}>
          {/* Animal from Location */}
          <NewSelect 
            header={t("operationsPages.newLocation", {defaultValue: "new location"})}
            options={[]}
            startEnhancer={glyphs.Location({})}
          />
          <Button content={t("buttons.save", {defaultValue: "save"})}/>
        </div>
      }
    />

  </>)
}